import { collection, addDoc, Timestamp } from "firebase/firestore";
import { firestoreDB } from "../config/firebase_config";

export interface TableBooking {
  restaurantId: string;
  restaurantName: string;
  numberOfPeople: number;
  bookingDate: string;
  bookingTime: string;
  phoneNumber: string;
  createdAt: Timestamp;
  status: "PENDING" | "CONFIRMED" | "CNACELLED";
}

export interface CreateBookingInput {
  restaurantId: string;
  restaurantName: string;
  numberOfPeople: number;
  bookingDate: string;
  bookingTime: string;
  phoneNumber: string;
}

/**
 * Create a new table booking in Firestore
 */
export async function createTableBooking(
  bookingData: CreateBookingInput
): Promise<string> {
  try {
    const bookingRef = collection(firestoreDB, "table_booking");

    const booking: TableBooking = {
      ...bookingData,
      createdAt: Timestamp.now(),
      status: "PENDING",
    };

    const docRef = await addDoc(bookingRef, booking);
    return docRef.id;
  } catch (error: any) {
    console.error("Error creating table booking:", error);
    throw new Error(
      error?.message || "Failed to create table booking. Please try again."
    );
  }
}
